import { FC, useCallback } from 'react';

import { boundActionsFactory } from 'shared/hooks/useBoundActions';
import { trackClickToOffer } from 'shared/store/analytics/actions/trackClickToOffer';

import { FlexOffice as Component } from './FlexOffice';
import { IFlexOffice } from './types';

const useBoundActions = boundActionsFactory({
  trackClickToOffer,
});

export const FlexOffice: FC<IFlexOffice> = props => {
  const { id } = props;

  const boundActions = useBoundActions();

  const handleTrackClickToOffer = useCallback<VoidFunction>(() => {
    boundActions.trackClickToOffer(id);
  }, [boundActions, id]);

  return <Component {...props} trackClickToOffer={handleTrackClickToOffer} />;
};
